import { API } from 'global/api'
import { api, headers } from './api'
import { type RootState } from './store'
import { type AppPopup } from 'global/types/app-config/in-app-popup'
export interface NotificationsQueryParams {
  start?: number
  length?: number
}

const appConfigApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getInAppPopup: builder.query<AppPopup, void>({
      query: () => ({
        url: API.IN_APP_POPUP_URL,
        method: 'GET',
        headers: headers()
      })
    })
  })
})

// notifs selector
export const appConfig = (state: RootState) => state.appConfig

export const { useGetInAppPopupQuery, reducer: appConfigReducer } = appConfigApi
